{
  "version": 1,
  "asset_id": "2063462f-ac02-4fca-8687-5c6f023cd80d",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/2063462f-ac02-4fca-8687-5c6f023cd80d/svc-google-business-profile-1200.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/2063462f-ac02-4fca-8687-5c6f023cd80d/svc-google-business-profile-1200.webp",
  "original_filename": "svc-google-business-profile-1200.webp",
  "size": 9166,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:50Z"
}
